<script setup>
  import { computed } from 'vue';
  import ToggleInputDefault from "@/components/controls/ToggleInputDefault.vue";
  import Icon from "@/components/icons/Icon.vue";

  const FREE_PREVIEW_MODELS = [279];
  const FREE_PREVIEW_ALL_MEMBER_LEVELS_MODELS = [280];

  const props = defineProps({
    model: {
      type: Object,
      required: true
    },
    // Input group name (shared across the selector's items).
    name: {
      type: String,
      required: true
    },
    multiSelect: {
      type: Boolean,
      default: false
    }
  });

  defineEmits(['input:change']);

  // The selector's shared selection (array in multi-select, scalar otherwise).
  const selected = defineModel();

  const inputId = computed(() => `${props.name}-${props.model.model_id}`);

  const hasFreePreview = computed(() => FREE_PREVIEW_MODELS.includes(props.model.model_id));
  const hasFreePreviewAllMemberLevels = computed(() => FREE_PREVIEW_ALL_MEMBER_LEVELS_MODELS.includes(props.model.model_id) );
  const isPreview = computed(() => hasFreePreview.value || hasFreePreviewAllMemberLevels.value);

  const attributes = computed(() => ({
    id: inputId.value,
    value: props.model.model_id,
    inputType: props.multiSelect ? 'checkbox' : 'radio',
    disabled: props.model.upgrade_available,
  }));

  const isSelected = computed(() =>
    props.multiSelect
      ? Array.isArray(selected.value) && selected.value.includes(props.model.model_id)
      : selected.value === props.model.model_id
  );
</script>

<template>
  <div class="jwx-model-selector__model">
    <ToggleInputDefault
      @input:change="$emit('input:change', $event)"
      :attributes="attributes"
      :name="name"
      :disabled="model.upgrade_available && !hasFreePreview"
      v-model="selected"
    />
    <label
      :for="inputId"
      class="jwx-model-selector__label"
      :data-selected="isSelected"
      :data-premium="model.is_premium"
      :data-preview="isPreview"
    >
      <p class="jwx-model-selector__label-text">{{ model.model_short_name || model.model_name }}</p>
      <span
        v-if="hasFreePreview && model.upgrade_available || hasFreePreviewAllMemberLevels"
        class="jwx-model-selector__badge"
        data-type="preview"
      >
        <Icon name="sparkle" />
        Preview
      </span>
      <span
        v-else-if="model.is_pro_only"
        class="jwx-model-selector__pro-badge"
        :data-upgrade-available="model.upgrade_available"
      >
        Pro
        <Icon v-if="model.upgrade_available" name="lock" />
      </span>
      <Icon v-else-if="model.upgrade_available" name="lock" />
      <Icon v-else-if="!model.upgrade_available && model.is_premium" name="premium-badge" />
    </label>
  </div>
</template>
